module.exports = __webpack_public_path__ + "img/ISO20000.4922c204.png";